import { render } from "./Workorder_GDBH.vue?vue&type=template&id=43f86c3a"
import script from "./Workorder_GDBH.vue?vue&type=script&lang=js"
export * from "./Workorder_GDBH.vue?vue&type=script&lang=js"

import exportComponent from "E:\\IdeaProjects\\jgwgxt-qt\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__